import { IconPropsType } from "../../types"

export const ListOfTicks = (props: IconPropsType) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" className={`w-5 h-5 ` + props.additionalStyle}>
            <g id="Frame">
                <path id="Vector" d="M3.5 5.5L5 7L7.5 4.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path id="Vector_2" d="M3.5 11.5L5 13L7.5 10.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path id="Vector_3" d="M3.5 17.5L5 19L7.5 16.5" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path id="Vector_4" d="M11 6H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path id="Vector_5" d="M11 12H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path id="Vector_6" d="M11 18H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </g>
        </svg>
    )
}